import ShopType from "@/enum/ShopType";
import getAuthShopUrl from "@/services/getAuthShopUrl";
import KWAIShop from "./KWAIShop";
import PDDShop from "./PDDShop";

const Shop = {
    [ShopType.PINDUODUO]: PDDShop.PINDUODUO,
    [ShopType.TAOBAO]: {
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01fOprAy2DwkARNFfGA_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.TAOBAO),
    },

    TMALL: {
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01kcxYZk2DwkAVyHKpp_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.TAOBAO),
    },

    TAOTE: {
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01Xy81Wh2DwkAdkNssX_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.TAOBAO),
    },

    [ShopType.TAOBAO_DISTRIBUTION]: {
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN01ivSIoO2DwkAYZMdC5_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.TAOBAO),
    },
    [ShopType.DOUDIAN]: {
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN010pQWQa2DwkExr73Jk_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.DOUDIAN}`,
    },
    [ShopType.JD]: {
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01R6og462DwkAQ1VkeG_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.JD),
    },
    [ShopType.JD_PURCHASE]: {
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01qUAuzl2DwkVep8if1_!!54458674.png",
        auth: getAuthShopUrl(ShopType.JD_PURCHASE),
    },
    [ShopType.ALIBABA]: {
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01b9UpYr2DwkANNiBgX_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.ALIBABA),
    },

    [ShopType.DOUDIAN_IOP]: {
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01GFJgcM2DwkHlGlDkj_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.DOUDIAN_IOP}`,
    },

    [ShopType.DOUDIAN_SUPPLIER]: {
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01OPf4hv2DwkF2V0DpC_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.DOUDIAN_SUPPLIER}`,
    },

    [ShopType.KWAI]: KWAIShop.KWAI,

    [ShopType.CHANNEL_SHOP]: {
        image: "https://img.alicdn.com/imgextra/i3/54458674/O1CN01Z6tBLg2DwkYvhEsRg_!!54458674.png",
        auth: `/login/selectLoginMethod?shopType=${ShopType.CHANNEL_SHOP}`,
    },
    [ShopType.CHANNEL_SHOP_DROPSHIP]: {
        image: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01E3qPHwRnoaE1OrGw_!!54458674.png",
        auth: `/login/selectLoginMethod?shopType=${ShopType.CHANNEL_SHOP_DROPSHIP}`,
    },
    [ShopType.XIAOHONGSHU]: {
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN01474qK72DwkAWqzEYW_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.XIAOHONGSHU}`,
    },
    [ShopType.ALI_C2M]: {
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN016giEVW2DwkAPyCaKJ_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.ALI_C2M}`,
    },
    [ShopType.KWAI_DROPSHIP]: {
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN019iFCC02DwkHYZfaf5_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.KWAI_DROPSHIP}`,
    },
    [ShopType.KTT]: {
        image: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01qpSdvo2DwkNQnBukN_!!54458674.png",
        auth: `/login/selectLoginMethod?shopType=${ShopType.KTT}`,
    },
    [ShopType.WEIDIAN]: {
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN017GICYV2DwkAWqv8sG_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.WEIDIAN}`,
    },
    [ShopType.AIKUCUN]: {
        image: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01YZfmmD2DwkAVyFBVx_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.AIKUCUN}`,
    },
    [ShopType.SUNING]: {
        image: "https://img.alicdn.com/imgextra/i3/54458674/O1CN01KH7WLs2DwkAUDpcIZ_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.SUNING}`,
    },
    [ShopType.HAIZIWANG]: {
        image: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01JNBdeu2DwkANy6Vh2_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.HAIZIWANG}`,
    },
    JINGLING: {
        image: "https://img.alicdn.com/imgextra/i2/54458674/O1CN0134bGkx2DwkHeY2xf9_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.WEBUY}`,
    },

    [ShopType.WEBUY]: {
        image: "https://img.alicdn.com/imgextra/i3/54458674/O1CN019M7gnh2DwkASp1ure_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.WEBUY}`,
    },
    [ShopType.YOUZAN]: {
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN01p0QYwy2DwkAQ1Xpkn_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.YOUZAN}`,
    },
    [ShopType.DUXIAODIAN]: {
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01Sv9SV02DwkAVH2O2i_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.DUXIAODIAN}`,
    },

    [ShopType.WEIMOB_EC]: {
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01PdUbvx2DwkAQYhlCy_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.WEIMOB_EC}`,
    },
    [ShopType.MOGUJIE]: {
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN014YFHtR2DwkAVyIk6y_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.MOGUJIE}`,
    },
    [ShopType.DOUBB]: {
        image: "https://img.alicdn.com/imgextra/i1/54458674/O1CN01Rqw74Y2DwkWBUZYXI_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.DOUBB}`,
    },
};

export default Shop;
